<template>
    <v-menu
        :disabled="disabled"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                color="black"
                :disabled="disabled"
                v-model="color"
                :label="label"
                prepend-icon="mdi-palette"
                readonly
                v-on="on"
            ></v-text-field>
        </template>
        <v-color-picker class="ma-2" dot-size="30" v-model="color" @input="$emit('input', color)"></v-color-picker>
    </v-menu>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                default: "Selecione uma Cor"
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                color: "",
            };
        },
    };
</script>

<style>
</style>
